import { render, staticRenderFns } from "./Production.vue?vue&type=template&id=e35896c2&"
import script from "./Production.vue?vue&type=script&lang=js&"
export * from "./Production.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports